import React from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'react-qr-code';

function VisitQRConfirm() {
  const { id } = useParams();
  const confirmUrl = `${window.location.origin}/visit/${id}/confirm`;

  return (
    <div className="p-6 text-center">
      <h2 className="text-xl font-semibold mb-4">Parent Signature – G-sign Confirmation</h2>
      <p className="mb-4">Scan this QR code with the parent's device:</p>
      <div className="inline-block bg-white p-4 shadow rounded">
        <QRCode value={confirmUrl} size={256} />
      </div>
      <p className="mt-4 text-sm text-gray-600 break-all">{confirmUrl}</p>
      <p className="text-xs text-gray-500 mt-3">
        For security and compliance, parent location (if permitted) will be recorded during confirmation.
      </p>
    </div>
  );
}

export default VisitQRConfirm;


